import React from 'react';
import { Link } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/outline';

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-dark-950 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white dark:bg-dark-800 py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center">
                    <XCircleIcon className="mx-auto h-16 w-16 text-red-500" />

                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">
                        Payment Cancelled
                    </h2>

                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        The payment process was cancelled. No charges were made.
                    </p>

                    <div className="mt-6">
                        <Link
                            to="/#pricing"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            Return to Pricing
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
